@if (ready) {
  <div class="">
    <!-- <h2 class="h2-xs mt-1 mb-2">Run options</h2> -->
    <table class="table table-sm text-sm table-condensed">
      <tbody>
        <tr>
          <td>
            @if (validatedTool.singleJobValidation.valid) {
              <span class="fas fa-fw fa-check-circle text-success" aria-hidden="true"></span>
            }
            @if (!validatedTool.singleJobValidation.valid) {
              <span>
                <i class="fas fa-fw fa-exclamation-circle text-warning" aria-hidden="true"></i>
              </span>
            }
          </td>
          <td class="text-nowrap">Run Tool</td>
          <td class="w-100">
            @if (validatedTool.singleJobValidation.valid) {
              <div>{{ getRunSingleDescription() }}</div>
            }
            @if (!validatedTool.singleJobValidation.valid) {
              <div class="alert alert-warning p-1 mb-0">
                {{ getRunSingleDescription() }}
              </div>
            }
          </td>
        </tr>
        <tr>
          <td>
            @if (validatedTool.runForEachValidation.valid) {
              <span class="fas fa-fw fa-check-circle text-success" aria-hidden="true"></span>
            }
            @if (!validatedTool.runForEachValidation.valid) {
              <span>
                <i class="fas fa-fw fa-exclamation-circle text-warning" aria-hidden="true"></i>
              </span>
            }
          </td>
          <td class="text-nowrap">Run Tool for Each File</td>
          <td>
            @if (validatedTool.runForEachValidation.valid) {
              <div>
                Runs the tool {{ validatedTool.selectedDatasets.length }} times. Each time one of the selected
                {{ validatedTool.selectedDatasets.length }} files is used as a single input for the tool.
              </div>
            }

            @if (!validatedTool.runForEachValidation.valid) {
              <div class="alert alert-warning p-1 mb-0">
                {{ validatedTool.runForEachValidation.message }}
              </div>
            }
          </td>
        </tr>
        <tr>
          <td class="no-bottom-border">
            @if (validatedTool.runForEachSampleValidation.valid) {
              <span class="fas fa-fw fa-check-circle text-success" aria-hidden="true"></span>
            }
            @if (!validatedTool.runForEachSampleValidation.valid) {
              <span>
                <i class="fas fa-fw fa-exclamation-circle text-warning" aria-hidden="true"></i>
              </span>
            }
          </td>
          <td class="text-nowrap" class="no-bottom-border">Run Tool for Each Sample</td>
          <td class="no-bottom-border">
            @if (validatedTool.runForEachSampleValidation.valid) {
              <div>
                {{ getRunForEachSampleDescription() }}
              </div>
            }

            @if (!validatedTool.runForEachSampleValidation.valid) {
              <div class="alert alert-warning p-1 mb-0">
                {{ getRunForEachSampleDescription() }}
              </div>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>
}
